import React, { useState, useEffect, useContext } from 'react';
import * as fkn from "../../lib/fkn";
import * as net from "../../lib/net";
import Dt_Cal from "../../lib/ui/dt_cal";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

class Pms_Krubba extends React.Component {
  constructor(props, context) {
    super(props);

    this.webStore = props.store;
    this.state = { pgid: 11, tra: [] };
    this.state.fdat = new Date();
    this.state.tdat = new Date();
    this.state.fkn = "";
    //this.state.units = [];
    //context.posrend = this;
    let cdat = new Date();
    let formatted_date = cdat.getFullYear() + "-" + (cdat.getMonth() + 1) + "-" + cdat.getDate();
    this.state.today = formatted_date;
    this.state.fdatum = formatted_date;
    this.state.tdatum = formatted_date;
  }
  componentDidUpdate() {
    let value = this.context;
    /* ... */
  }
  componentWillUnmount() {
    let value = this.context;
    /* ... */
  }
  componentDidMount() {
    //this.props.fetchWells()
    //  .then(res => this.setState({ wells: res.wells }) )
    //this.trans();
  }

  body_style() {
      var css = {};
      css.height = window.innerHeight - 280;
      return css;
  }
  tb_style() {
      var css = {};
      css.height = window.innerHeight - 250;
      return css;
  }
  onUnitChange(e) {
        this.setState({unit: e.value});
  }
  change_fdat(e) {
    //let cdat = this.state.seldate;
      if(e.value == null) return;

    let cdat = e.value;
    let formatted_date = cdat.getFullYear() + "-" + (cdat.getMonth() + 1).toString().tonum(2) + "-" + cdat.getDate().toString().tonum(2);
    this.setState({fdat: e.value});
    this.setState({fdatum: formatted_date});
    this.setState({tra: [] });
  }
  change_tdat(e) {
    //let cdat = this.state.seldate;
      if(e.value == null) return;
    let cdat = e.value;
    let formatted_date = cdat.getFullYear() + "-" + (cdat.getMonth() + 1).toString().tonum(2) + "-" + cdat.getDate().toString().tonum(2);
    this.setState({tdat: e.value});
    this.setState({tdatum: formatted_date});
    this.setState({tra: [] });
  }
  change_fkn(e) {
    //let cdat = this.state.seldate;
    //alert(JSON.stringify(e));
    let fkn = e.target.value;
    this.setState({fkn: fkn});
    this.setState({tra: [], tsa: [], tta: [] });
  }

  dt_fkn() {
    var self = this;
    var datum = this.state.datum;
    var today = this.state.today;

    if(this.state.fkn == "TRS") this.dt_hbok();
    else if(this.state.fkn == "TOT") this.dt_htot();
    else this.dt_hsum();
  }

  dt_hbok() {
    var self = this;
    var prm = {};
    prm.req = "pms.eko_red.red_hbok";
    prm.fdat = this.state.fdatum;
    prm.tdat = this.state.tdatum;

    //gda.wndLoading("Hämtar");
    //net.sio_req(prm)
    net.sid_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret.rco.tot));

        if(ret.ok != "000") {
            return;
        }
        var o = {};
        //o.deps = ret.rco;
        //alert(JSON.stringify(o));
        self.setState({tra: ret.rca });
        //toastr.success("OK", "SAPI");
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
        //gda.wndError(txt);
    });
    }

  dt_hsum() {
    var self = this;
    var prm = {};
    prm.req = "pms.eko_red.red_hsum";
    prm.fdat = this.state.fdatum;
    prm.tdat = this.state.tdatum;

    //gda.wndLoading("Hämtar");
    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret.rca));

        if(ret.ok != "000") {
            return;
        }
        var o = {};
        //o.deps = ret.rco;
        //alert(JSON.stringify(o));
        self.setState({tra: ret.rca });
        //toastr.success("OK", "SAPI");
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
        //gda.wndError(txt);
    });
    }

  render() {
    return (
    <div className="web-app" style={{margin: "0px", padding: "5px 10px"}}>
    <h3>Hotell Krubba</h3>

    <div className="flex-row flex-space-between">
        <div className="flex-row">
            <div className="flex-row">
                <div className="dt-btn-01" onClick={() => this.subday() } ><FontAwesomeIcon icon="minus" size="1x" /></div>
                <Dt_Cal dts={this.state.dts} rp="1" ref={this.dt_dt} getValue={(e)=> this.dt_dat(e)} />
                <div className="dt-btn-01" onClick={() => this.addday() } ><FontAwesomeIcon icon="plus" size="1x" /></div>
            </div>
            <div className="flex-row">
                <div className="dt-btn-01" onClick={() => this.subday() } ><FontAwesomeIcon icon="minus" size="1x" /></div>
                <Dt_Cal dts={this.state.dts} rp="1" ref={this.dt_dt} getValue={(e)=> this.dt_dat(e)} />
                <div className="dt-btn-01" onClick={() => this.addday() } ><FontAwesomeIcon icon="plus" size="1x" /></div>
            </div>
        </div>
        <button className="btn btn-hw-blue w150 ripple" onClick={() => this.dt_hbok() } aria-label="System" >
            Visa
        </button>
    </div>
    <div className="divider">
    </div>

        <div className="web-row">
            <table className="table table-bordered table-hover tb fixed_header">
                <thead>
                <tr>
                    <th>Datum</th>
                    <th>Rum</th>
                    <th>Typ</th>
                    <th>Tid</th>
                    <th>Konto</th>
                    <th>Text</th>
                    <th>Antal</th>
                    <th>Pris</th>
                    <th>Tkn</th>
                </tr>
                </thead>
                <tbody style={ this.tb_style() }>
                { this.state.tra.map((row, key) =>
                    <tr id={ row.e0datum } ng-dblclick="trans_open(row);">
                        <td>{ row.e0datum.cdidate() }</td>
                        <td>{ row.e0rumsnr }</td>
                        <td>{ row.e0typ }</td>
                        <td>{ row.e0klockan }</td>
                        <td>{ row.e0kontonr }</td>
                        <td>{ row.e0text }</td>
                        <td>{ row.e0antal.ztrim() }</td>
                        <td>{ row.e0pris.cdipris() }</td>
                        <td>{ row.e0tkn }</td>
                    </tr>
                )}
                </tbody>
            </table>
        </div>
    </div>
  );
}
}
export default Pms_Krubba;
